/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FixedPriceQuoteTemplateLineResource
 */
export interface FixedPriceQuoteTemplateLineResource {
    /**
     * 
     * @type {string}
     * @memberof FixedPriceQuoteTemplateLineResource
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceQuoteTemplateLineResource
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceQuoteTemplateLineResource
     */
    unitPriceExcludingTaxes: number;
}

/**
 * Check if a given object implements the FixedPriceQuoteTemplateLineResource interface.
 */
export function instanceOfFixedPriceQuoteTemplateLineResource(value: object): value is FixedPriceQuoteTemplateLineResource {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('unitPriceExcludingTaxes' in value) || value['unitPriceExcludingTaxes'] === undefined) return false;
    return true;
}

export function FixedPriceQuoteTemplateLineResourceFromJSON(json: any): FixedPriceQuoteTemplateLineResource {
    return FixedPriceQuoteTemplateLineResourceFromJSONTyped(json, false);
}

export function FixedPriceQuoteTemplateLineResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceQuoteTemplateLineResource {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'quantity': json['quantity'],
        'unitPriceExcludingTaxes': json['unitPriceExcludingTaxes'],
    };
}

export function FixedPriceQuoteTemplateLineResourceToJSON(value?: FixedPriceQuoteTemplateLineResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'quantity': value['quantity'],
        'unitPriceExcludingTaxes': value['unitPriceExcludingTaxes'],
    };
}

